import React, { useEffect, useState } from "react";
import { auth, db, googleProvider } from "../firebase";
import { signInWithPopup, onAuthStateChanged, signOut } from "firebase/auth";
import { ref, get } from "firebase/database";
import { useNavigate } from "react-router-dom";
import { saveSessionRole } from "../roles";

const DOMAIN = "vnrvjiet.in";

async function isAllowedParticipant(email) {
  if (!email) return false;
  if (email.toLowerCase().endsWith(`@${DOMAIN}`)) return true;
  const key = btoa(email.toLowerCase());
  const snap = await get(ref(db, `authExceptions/${key}`)); // admin-maintained exceptions
  return snap.exists() && !!snap.val();
}

export default function ParticipantLogin() {
  const [err, setErr] = useState("");
  const [user, setUser] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u || null);
    });
    return () => unsub();
  }, []);

  async function loginWithGoogle() {
    setErr("");
    try {
      const cred = await signInWithPopup(auth, googleProvider);
      const email = cred.user?.email || "";
      if (!(await isAllowedParticipant(email))) {
        setErr(`Use your institute email *@${DOMAIN} or ask admin to add your email to exceptions.`);
        await signOut(auth);
        return;
      }
      saveSessionRole("participant", { email, name: cred.user.displayName || "" });
      nav("/participant");
    } catch (e) {
      setErr(e.message);
    }
  }

  async function logout() { await signOut(auth); }

  return (
    <div className="max-w-md mx-auto bg-white rounded-2xl shadow p-6 space-y-4">
      <h1 className="text-2xl font-bold">Participant Login</h1>
      <p className="text-sm text-gray-600">Sign in with Google using your institute email.</p>
      <button onClick={loginWithGoogle} className="w-full py-3 rounded-xl border hover:bg-gray-50">
        Continue with Google
      </button>
      {err && <div className="text-red-600 text-sm">{err}</div>}
      {user && (
        <button onClick={logout} className="w-full py-3 rounded-xl border hover:bg-gray-50">Sign Out</button>
      )}
    </div>
  );
}
